import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem} from '../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../shared/Models/columns';
import * as moment from 'moment';
import {BroadcastService} from '../../../shared/Services/broadcast.service';
import {AuthenticationService} from '../../../shared/Services/authentication.service';
import {InternalPackagingLabelService} from '../../Services/internal-packaging-label.service';
import {environment} from '../../../../environments/environment';
import {Router} from '@angular/router';

@Component({
  selector: 'app-packaging-label',
  templateUrl: './internal-packaging-label.component.html',
  styleUrls: ['./internal-packaging-label.component.scss']
})
export class InternalPackagingLabelComponent implements OnInit {

  public grid: Grid;
  public baseUrl = environment.apiUrl;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  constructor(
    private internalPackagingLabelService: InternalPackagingLabelService,
    private broadcastService: BroadcastService,
    private router: Router,
    private auth: AuthenticationService,
  ) { }

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.backoffice.packaging-label.date',
          prop: 'date',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.backoffice.packaging-label.number',
          prop: 'code',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-download fa-lg',
              tooltip: 'global.download',
              onclick: (row) => {
                if (row.labelFile) {
                  this.internalPackagingLabelService.getInternalPackagingLabelPdf(row.labelFile.path, row.labelFile.filename)
                    .subscribe(() => {});
                }
              },
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.internalPackagingLabelService,
      rememberURL: this.router.url,
      method: 'getInternalPackagingLabel',
      defaultSort: 'id',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          hasNormalSearch: false,
        }
      ],
    };
  }

  refreshGid(event) {
    if (event) {
      this.broadcastService.broadcast('refreshGrid', 'getInternalPackagingLabel');
    }
  }
}
